import React, { useContext, useEffect, useState } from 'react'
import { Alert, Snackbar } from '@cicero/ui'
import { StoreContext } from '../models/services'

export const OfflineSyncState = () => {
  const [open, setOpen] = useState(false)
  const [unsynced, setUnsynced] = useState(0)
  const store = useContext(StoreContext)

  const handleClose = (ev: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') { return }
    setOpen(false)
  }

  useEffect(() => {
    const subs = [
      store.API.online$.subscribe(async isOnline => {
        setOpen(!isOnline)
      }),
      store.API.unsynced$.subscribe(count => {
        setUnsynced(count)
      }),
    ]
    return () => { subs.map(sub => sub.unsubscribe()) }
  }, [store])

  return <Snackbar open={open} onClose={handleClose}>
    <Alert onClose={handleClose} severity="warning">
      You are Offline.
      { unsynced > 0 ? ` ${unsynced} change${unsynced > 2 ? 's' : ''} to sync.` : null }
    </Alert>
  </Snackbar>
}
